import t from 'react-translate';
import { useSelector } from 'react-redux';

import { LoaderType } from 'shared/components/loading-placeholder';
import AiGeneratingLoader from '../shared/ai-generating-loader';
import GradientAiIcon from '../shared/gradient-ai-icon';
import ActivityItem from './activity-item';

import { suggestedActivitiesStyles } from './styles';

const SuggestedActivities = () => {
  const { activities, isLoaded } = useSelector(state => ({
    activities: Object.values(state.app.aiSuggestComponent.activitySets),
    isLoaded: state.app.aiSuggestComponent.isLoaded,
  }));

  return (
    <div
      className='d-flex flex-column align-items-center justify-content-center w-100'
      css={suggestedActivitiesStyles}
    >
      <div className='d-flex align-items-center justify-content-center'>
        <GradientAiIcon icon='gen-ai' size='medium' className='pr-2' />
        <span className='text-xl font-weight-light'>
          {t.LECTURE_PAGES.LHS.NOVO_AI.SUGGEST_ACTIVITIES[
            !isLoaded ? 'GENERATING_HEADER' : 'GENERATED_HEADER'
          ](activities.length)}
        </span>
      </div>
      <div className='list-container w-100'>
        {activities.map((componentSet) => (
          <ActivityItem componentSet={componentSet} key={componentSet.id} />
        ))}
      </div>
      {!isLoaded && <AiGeneratingLoader loaderType={LoaderType.HALF} />}
    </div>
  );
};

export default SuggestedActivities;
